import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';

const AllUsers = () => {
    const { isSidebarOpen } = useSidebar();
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);

    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);


    const openDeleteConfirm = (user) => {
        setUserToDelete(user);
        setShowDeleteConfirm(true);
    };


    // Fetch users from backend
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch("https://backend.impactjournal.co.in/register/all-users");
                const data = await response.json();
                setEmployees(data);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };

        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleDelete = (email) => {
        const updatedEmployees = employees.filter(employee => employee.email !== email);
        setEmployees(updatedEmployees);
    };

    const confirmDelete = async () => {
        if (!userToDelete) return;

        try {
            const response = await fetch(
                `https://backend.impactjournal.co.in/register/${userToDelete.id}`,
                { method: "DELETE" }
            );

            const result = await response.json();

            if (response.ok) {
                // Remove user from UI
                setEmployees(prev => prev.filter(u => u.id !== userToDelete.id));
                setShowDeleteConfirm(false);
                setUserToDelete(null);
            } else {
                alert(result.message || "Failed to delete user");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Server error while deleting user.");
        }
    };


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h1 className="dashboard-title">All users</h1>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Email ID</th>
                                <th style={{ minWidth: "100px" }}>Name</th>
                                <th>Number</th>
                                <th>Gender</th>
                                <th>Designation</th>
                                <th style={{ minWidth: "150px" }}>Address</th>
                                <th>City</th>
                                <th>Pincode</th>
                                <th>State</th>
                                <th>Country</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{employee.email}</td>

                                        <td>{employee.name}</td>
                                        <td>{employee.mobile}</td>
                                        <td>{employee.gender}</td>
                                        <td>{employee.designation}</td>
                                        <td>{employee.address}</td>
                                        <td>{employee.city}</td>
                                        <td>{employee.pincode}</td>
                                        <td>{employee.state}</td>
                                        <td>{employee.country}</td>
                                        <td>
                                            <button
                                                onClick={() => openDeleteConfirm(employee)}
                                                className="delete-btn"
                                                style={{ background: "transparent", border: "none", cursor: "pointer" }}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            {showDeleteConfirm && (
                <div className="account-modal-backdrop">
                    <div className="account-modal-content">
                        <h3>Confirm Delete</h3>
                        <p>Are you sure you want to delete user <strong>{userToDelete?.email}</strong>?</p>

                        <div className="account-modal-buttons">
                            <button className="account-confirm-btn" onClick={confirmDelete}>
                                Yes, Delete
                            </button>

                            <button
                                className="account-cancel-btn"
                                onClick={() => {
                                    setShowDeleteConfirm(false);
                                    setUserToDelete(null);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default AllUsers;
